import { isAudible, isVisible } from 'content-creation-common/utils/content';

import {
  AUDIBLE_CONTENT_TYPES,
  CONTENT_TYPE,
  GLOBAL_ID,
} from '../../../constants';

import { isNotNil, isObject } from '../../../util/object';
import { isGroup } from '../../group/util';

export const isChangedFromTemplate = ({
  content,
  currentTemplate,
  medium,
  templateElement,
}) => {
  /*
   If the template is owned by the current org/publisher (not Global), then we don't mind so it is valid
   Note this check only succeeds if the user has not refreshed the page.
   We need to save which template was used and load it in the future
   */
  if (
    isObject(currentTemplate) &&
    currentTemplate.organizationId !== GLOBAL_ID &&
    currentTemplate.publisherId !== GLOBAL_ID
  ) {
    return true;
  }

  if (isNotNil(content)) {
    const { contentType } = content;

    /* If content is invisible and muted, it is a valid layer */
    if (
      !isVisible(content) &&
      !(AUDIBLE_CONTENT_TYPES.has(contentType) && isAudible(content))
    ) {
      return true;
    }

    /* If the content is audio and it is muted, we don't care, so it's valid. */
    if (contentType === CONTENT_TYPE.AUDIO && !isAudible(content)) {
      return true;
    }

    /* If the content is either text, shape, or group, we do not care and so it is valid */
    if (
      contentType === CONTENT_TYPE.SHAPE ||
      contentType === CONTENT_TYPE.TEXT ||
      isGroup(contentType)
    ) {
      return true;
    }
  }

  /* If the media has been flagged as being explicitly from the template it is not valid */
  if (isNotNil(medium) && medium.fromTemplate) {
    return false;
  }

  /* If this element does not exist in the current template, then it is valid */
  if (!templateElement) {
    return true;
  }

  /* Finally, check if the template element has the same content ID */
  return templateElement.contentId !== content.contentId;
};
